export const setForMediumScreen = value => `${value * 100 / 1920}vw`;
export const setForMediumScreenWithRestriction = value => {
  if (window.innerWidth < 1440) {
    return `${value}px`;
  }
  return setForLargeScreen(value);
};
export const setForLargeScreen = value => `${value * 2560 / 1920}px`;